import api, { ApiResponse } from './api'

interface AuthResponse {
  token?: string | null
  merchant?: {
    id: string
    email: string
    name?: string
    twoFactorEnabled?: boolean
  } | null
  requiresTwoFactor?: boolean
  loginChallengeToken?: string | null
}

export function sendCode(email: string, type: string, turnstileToken?: string): Promise<ApiResponse<null>> {
  return api.post('/v1/merchant/auth/send-code', { email, type, turnstileToken })
}

export function register(
  email: string,
  password: string,
  code: string,
  consentAccepted: boolean,
  legalTermsVersion: string,
  inviteCode?: string,
): Promise<ApiResponse<AuthResponse>> {
  return api.post('/v1/merchant/auth/register', {
    email,
    password,
    code,
    consentAccepted,
    legalTermsVersion,
    inviteCode,
  })
}

export function login(email: string, password: string, turnstileToken?: string): Promise<ApiResponse<AuthResponse>> {
  return api.post('/v1/merchant/auth/login', { email, password, turnstileToken })
}

export function verifyLoginTwoFactor(loginChallengeToken: string, totpCode: string): Promise<ApiResponse<AuthResponse>> {
  return api.post('/v1/merchant/auth/login/verify-2fa', { loginChallengeToken, totpCode })
}

export function resetPassword(
  email: string,
  code: string,
  newPassword: string
): Promise<ApiResponse<null>> {
  return api.post('/v1/merchant/auth/reset-password', { email, code, newPassword })
}

export function changePassword(data: {
  currentPassword: string
  newPassword: string
  totpCode?: string
}): Promise<ApiResponse<null>> {
  return api.patch('/v1/merchant/auth/change-password', data)
}

export function sendTwoFactorRebindCode(turnstileToken?: string): Promise<ApiResponse<null>> {
  return api.post('/v1/merchant/auth/two-factor/send-rebind-code', { turnstileToken })
}

export function createTwoFactorSetup(emailCode?: string): Promise<ApiResponse<{ secret: string; otpauthUrl: string; setupToken?: string }>> {
  return api.post('/v1/merchant/auth/two-factor/setup', { emailCode })
}

export function enableTwoFactor(data: { secret: string; totpCode: string; setupToken?: string }): Promise<ApiResponse<{ enabled: boolean }>> {
  return api.post('/v1/merchant/auth/two-factor/enable', data)
}
